import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { PAGINATION_SIZE } from "../../utils";
import BunkeyAPI from "../../api/BunkeyAPI"; //'../api/BunkeyAPI'
import PDFViewPresentational from "./PDFViewPresentational";
import { connect } from "react-redux";
import { showVersionHasChangedMessage } from "../../actions/CommentAction";
class VersionPdfViewContainer extends Component {
  constructor(props) {
    super(props);
    const { itemSelected } = this.props;

    let commonState = {
      exploreIndex: 0,
      currentPage: 1,
      navigateInput: 1,
      isUpdatingFromTag: false,
      isFetchingPages: false,
      document: itemSelected.document,
      isFlickityReady: false,
      previousNavigation: {
        previousPage: 1,
        navigate: false
      }
    };

    if (!itemSelected.isCurrentVersion) {
      commonState = {
        ...commonState,
        versionId: itemSelected.versionId
      };
    }
    this.state = commonState;
  }

  componentDidMount() {
    this.flkty.on("settle", this.onSettleFlickity);
    this.flkty.on("ready", this.onFlickityReady);
  }

  setFlickityRef = ref => {
    this.flkty = ref;
  };

  onSettleFlickity = () => {
    const { document, versionId } = this.state;
    this.setState({ exploreIndex: this.flkty.selectedIndex }, () => {
      if (
        (this.flkty.selectedIndex + 1) % PAGINATION_SIZE === 0 &&
        document.documentPages.length !== document.totalDocumentPages
      ) {
        const skipPage =
          (Number(this.flkty.selectedIndex) + 1) / PAGINATION_SIZE + 1;
        this.getPDFPages(document.client, versionId, skipPage);
      }
    });
  };

  onFlickityReady = () => {
    this.setState({ isFlickityReady: true });
  };

  getPDFPages = (workclient, versionId, skip, limit) => {
    const { isFetchingPages } = this.state;
    return new Promise((resolve, reject) => {
      if (!isFetchingPages) {
        this.setState({ isFetchingPages: true }, () => {
          this.fetchPdfPages(workclient, versionId, skip, limit)
            .then(data => {
              this.addNewPages(data.documentPages, data.totalDocumentPages);
              resolve();
            })
            .catch(err => {
              this.setState({ isFetchingPages: false });
              reject();
            });
        });
      } else {
        reject();
      }
    });
  };

  fetchPdfPages = (workclient, versionId, skip, limit) => {
    const { itemSelected } = this.props;

    if (itemSelected.isCurrentVersion) {
      return this.fetchPdfPagesForCurrentVersion(workclient, skip, limit);
    } else {
      return this.fetchPdfPagesForOtherVersion(
        workclient,
        versionId,
        skip,
        limit
      );
    }
  };

  fetchPdfPagesForCurrentVersion = (workclient, skip, limit) => {
    const { document } = this.state;
    const { showVersionHasChangedMessage, intl } = this.props;
    const url =
      `/clients/${workclient}/objects/${document._id}/document-pages` +
      (skip ? `?skipPages=${skip}` : "") +
      (limit ? `?limitPages=${limit}` : "");
    return new Promise((resolve, reject) => {
      BunkeyAPI({
        url: url,
        method: "GET",
        data: {
          client: workclient
        }
      })
        .then(resp => {
          if (resp.status === 200 && resp.data.uuid === document.uuid) {
            resolve(resp.data);
          } else {
            showVersionHasChangedMessage(intl);
            this.navigateTopPreviousPage();
            reject();
          }
        })
        .catch(err => {
          console.error(err);
          reject(err);
        });
    });
  };

  fetchPdfPagesForOtherVersion = (workclient, versionId, skip, limit) => {
    const url =
      `/clients/${workclient}/asset-versions/${versionId}/document-pages` +
      (skip ? `?skipPages=${skip}` : "") +
      (limit ? `?limitPages=${limit}` : "");

    return new Promise((resolve, reject) => {
      BunkeyAPI({
        url: url,
        method: "GET",
        data: {
          client: workclient
        }
      })
        .then(resp => {
          if (resp.status === 200) {
            resolve(resp.data);
          }
        })
        .catch(err => {
          console.error(err);
          reject(err);
        });
    });
  };
  navigateTopPreviousPage = () => {
    this.setState(
      (state, prevState) => {
        const { previousNavigation } = state;
        return {
          ...state,
          currentPage: previousNavigation.previousPage,
          navigateInput: previousNavigation.previousPage,
          exploreIndex: previousNavigation.previousPage
            ? previousNavigation.previousPage - 1
            : 0

          // previousNavigation: {
          //   previousPage: 1,
          //   navigate: false
          // }
        };
      },
      () => {
        this.updateFlicktyPosition();
      }
    );
  };

  updateFlicktyPosition = () => {
    const { exploreIndex } = this.state;
    this.flkty.select(exploreIndex);
  };

  addNewPages = (documentPages, totalDocumentPages) => {
    this.setState((state, props) => {
      const { document } = this.state;
      const newDocumentPages = [...document.documentPages, ...documentPages];
      return {
        ...state,
        isFetchingPages: false,
        document: {
          ...state.document,
          totalDocumentPages: totalDocumentPages,
          documentPages: newDocumentPages.filter((item, pos) => {
            return newDocumentPages.indexOf(item) === pos;
          })
        }
      };
    });
  };

  handlerSelectFlickity = index => {
    const { workclient } = this.props;
    const limit =
      Number(index) + (PAGINATION_SIZE - (Number(index) % PAGINATION_SIZE));

    this.setState(
      (state, prevState) => {
        const { previousNavigation, currentPage } = this.state;
        return {
          ...state,
          exploreIndex: index,
          currentPage: index + 1,
          navigateInput: index + 1,
          previousNavigation: {
            ...previousNavigation,
            previousPage: currentPage
          }
        };
      },
      () => {
        this.flkty.select(index);
        const { document, versionId } = this.state;

        if (
          Number(index) + 1 > document.documentPages.length &&
          document.documentPages.length !== document.totalDocumentPages
        ) {
          this.getPDFPages(workclient, versionId, 0, limit);
        }
      }
    );
  };

  handleonKeyUp = event => {
    const { document, versionId } = this.state;
    const index =
      event.target.value > document.totalDocumentPages
        ? document.totalDocumentPages
        : event.target.value < 1
        ? 1
        : event.target.value;
    const limit =
      Number(index) + (PAGINATION_SIZE - (Number(index) % PAGINATION_SIZE));

    if (event.key === "Enter") {
      this.setState(
        (state, prevState) => {
          const { previousNavigation, currentPage } = this.state;
          return {
            exploreIndex: index,
            currentPage: Number(index),
            navigateInput: Number(index),
            previousNavigation: {
              ...previousNavigation,
              previousPage: currentPage
            }
          };
        },
        () => {
          if (document.documentPages.length !== document.totalDocumentPages) {
            this.getPDFPages(document.client, versionId, 0, limit).then(() => {
              this.flkty.select(index - 1);
            });
          } else {
            this.flkty.select(index - 1);
          }
        }
      );
    }
  };

  handleOnChange2 = event => {
    const { document } = this.state;
    // const { navigateInput } = this.state
    const newValue = event.target.value;
    const isAllowed =
      /^\d*$/.test(newValue) && (newValue === "" || parseInt(newValue) >= 1);

    if (isAllowed) {
      if (newValue === "") {
        this.setState({ navigateInput: newValue });
      } else {
        const index =
          event.target.value > document.totalDocumentPages
            ? document.totalDocumentPages
            : event.target.value < 1
            ? 1
            : event.target.value;
        this.setState({ navigateInput: index });
      }
    }
  };

  goToPreviousPage = () => {
    const { currentPage } = this.state;

    if (currentPage - 1) this.handlerSelectFlickity(currentPage - 2);
  };

  goToNextPage = () => {
    const { currentPage, document } = this.state;
    if (document.totalDocumentPages - Number(currentPage)) {
      this.handlerSelectFlickity(Number(currentPage));
    }
  };
  render() {
    const {
      exploreIndex,
      navigateInput,
      document,
      isFetchingPages,
      currentPage
    } = this.state;
    const { isComparingVersion } = this.props;
    const showLoader =
      isFetchingPages && document.documentPages.length < currentPage;
    return (
      <React.Fragment>
        <PDFViewPresentational
          exploreIndex={exploreIndex}
          currentPage={currentPage}
          navigateInput={navigateInput}
          document={document}
          showLoader={showLoader}
          isReduxAware={false}
          setFlickityRef={this.setFlickityRef}
          handlerSelectFlickity={this.handlerSelectFlickity}
          // handlePdfTag ={this.handlePdfTag}
          goToPreviousPage={this.goToPreviousPage}
          handleonKeyUp={this.handleonKeyUp}
          handleOnChange2={this.handleOnChange2}
          goToNextPage={this.goToNextPage}
          isComparingVersion={isComparingVersion}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  showVersionHasChangedMessage
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(VersionPdfViewContainer)
);
